import styled from 'styled-components';
import React from 'react';
import { EventSource, MessageType } from '../../graphql/graphql';
import { HtmlContent } from '../HtmlContent';
import { log } from '../../lib/logger';
import { isNilOrEmpty } from '../../lib/utils';
import { SecureForm } from '../../design_system/SecureForm';
export const Bubble = styled.span `
  background: ${props => props.$bubbleBackgroundColor};
  padding: 1rem;
  margin: 0;
  border-radius: 0.25rem;
  max-width: unset;
  flex-grow: 0;
`;
const Content = styled.span `
  align-self: start;
  color: ${({ isAdvisor }) => (isAdvisor ? '#292929' : '#fff')};
  word-break: break-word;
  white-space: pre-wrap;

  a {
    color: ${({ isAdvisor }) => (isAdvisor ? '#292929' : '#fff')};
  }
`;
const CustomerAttachmentImage = styled.img `
  width: 148px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
`;
const CustomAttachmentContainer = styled.div `
  figure {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  figcaption {
    overflow: hidden;
    font-size: 0.9rem;
  }
`;
const CustomerAttachment = ({ src, caption, onClick, }) => {
    return (React.createElement(CustomAttachmentContainer, null,
        React.createElement("figure", null,
            React.createElement(CustomerAttachmentImage, { src: src, alt: "attachment image", className: "attachment", onClick: onClick }),
            caption && React.createElement("figcaption", { title: caption }, caption))));
};
const ChatMessageType = ({ message, onAttachmentClick, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    switch ((_a = message.messageEvent) === null || _a === void 0 ? void 0 : _a.messageType) {
        case MessageType.Attachment:
            return (React.createElement(CustomerAttachment, { "data-testid": "event-row-attachment", src: (_c = (_b = message.messageEvent) === null || _b === void 0 ? void 0 : _b.attachment) === null || _c === void 0 ? void 0 : _c.url, caption: (_e = (_d = message.messageEvent) === null || _d === void 0 ? void 0 : _d.attachment) === null || _e === void 0 ? void 0 : _e.caption, onClick: () => {
                    var _a, _b;
                    if (isNilOrEmpty((_b = (_a = message.messageEvent) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.url))
                        return;
                    onAttachmentClick === null || onAttachmentClick === void 0 ? void 0 : onAttachmentClick(message.messageEvent.attachment.url);
                } }));
        case MessageType.Question:
            if (!((_g = (_f = message === null || message === void 0 ? void 0 : message.messageEvent) === null || _f === void 0 ? void 0 : _f.question) === null || _g === void 0 ? void 0 : _g.text)) {
                log.error('expected non empty text for question', message);
                return null;
            }
            return (React.createElement(HtmlContent, { "data-testid": "event-row-question", makeLinksTargetBlank: true }, message.messageEvent.question.text));
        case MessageType.Command:
            if (!((_j = (_h = message === null || message === void 0 ? void 0 : message.messageEvent) === null || _h === void 0 ? void 0 : _h.command) === null || _j === void 0 ? void 0 : _j.text)) {
                log.error('expected non empty text for question', message);
                return null;
            }
            return (React.createElement(HtmlContent, { "data-testid": "event-row-command", makeLinksTargetBlank: true }, message.messageEvent.command.text));
        case MessageType.Text:
            if (!((_l = (_k = message === null || message === void 0 ? void 0 : message.messageEvent) === null || _k === void 0 ? void 0 : _k.text) === null || _l === void 0 ? void 0 : _l.message)) {
                log.error('expected non empty text for message', message);
                return null;
            }
            return (React.createElement(HtmlContent, { "data-testid": "event-row-text", findLinksInText: true, makeLinksTargetBlank: true }, message.messageEvent.text.message));
        default:
            log.error('unexpected message type', message);
            return null;
    }
};
export const MessageContent = ({ message, onAttachmentClick, primaryBubbleBackgroundColor, }) => {
    var _a;
    const isAdvisor = message.source === EventSource.Advisor;
    const bubbleBackgroundColor = isAdvisor
        ? '#eeeeee'
        : primaryBubbleBackgroundColor;
    if (((_a = message.messageEvent) === null || _a === void 0 ? void 0 : _a.messageType) === MessageType.SecureForm) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Bubble, { "$bubbleBackgroundColor": bubbleBackgroundColor },
                React.createElement(SecureForm, { url: message.messageEvent.secureForm.url, from: message.messageEvent.from, invitationId: message.messageEvent.secureForm.invitationId, title: message.messageEvent.secureForm.title }))));
    }
    return (React.createElement(Bubble, { "$bubbleBackgroundColor": bubbleBackgroundColor },
        React.createElement(Content, { isAdvisor: isAdvisor },
            React.createElement(ChatMessageType, { message: message, onAttachmentClick: onAttachmentClick }))));
};
//# sourceMappingURL=MessageContent.js.map